/**
 * Repositions the Swym wishlist button on mobile
 * Moves it from inside the swiper to be the first child of pdp-gallery-mobile
 */
(function() {
  function repositionWishlistButton() {
    const mobileGallery = document.querySelector('.pdp-gallery-mobile');
    const wishlistButton = document.querySelector('.pdp-gallery-mobile .swym-atw-btn-wrapper-for-img');
    
    if (!mobileGallery || !wishlistButton) {
      return;
    }
    
    // Check if button is already in the correct position (first child)
    if (mobileGallery.firstElementChild === wishlistButton) {
      return;
    }
    
    // Move wishlist button to be the first child of mobile gallery
    mobileGallery.insertBefore(wishlistButton, mobileGallery.firstElementChild);
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repositionWishlistButton);
  } else {
    repositionWishlistButton();
  }
  
  // Watch for the wishlist button being added by the app
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        const hasWishlistButton = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('swym-atw-btn-wrapper-for-img') ||
            node.querySelector?.('.swym-atw-btn-wrapper-for-img')
          )
        );
        
        if (hasWishlistButton) {
          setTimeout(repositionWishlistButton, 100);
        }
      }
    }
  });
  
  // Observe the mobile gallery for changes
  const mobileGallery = document.querySelector('.pdp-gallery-mobile');
  if (mobileGallery) {
    observer.observe(mobileGallery, {
      childList: true,
      subtree: true
    });
  }
})();

